import { GeoLocationMapView } from '../../components/location/GeoLocationMapView';

const regionSnapshots = [
  {
    id: 'area-core',
    name: '都心エリア',
    meta: 'ビル 6 / 点検 3',
    tag: '重点',
    tone: 'warn',
    latitude: 35.681236,
    longitude: 139.767125,
    categoryIcon: 'AlertOutlined',
    categoryColor: '#f4a430',
  },
  {
    id: 'area-bay',
    name: '湾岸エリア',
    meta: 'ビル 3 / 点検 1',
    tag: '稼働中',
    tone: 'ok',
    latitude: 35.6595,
    longitude: 139.795,
    categoryIcon: 'CheckCircleOutlined',
    categoryColor: '#2a9d8f',
  },
  {
    id: 'area-suburb',
    name: '郊外エリア',
    meta: 'ビル 3 / 未整理 1',
    tag: '安定',
    latitude: 35.6895,
    longitude: 139.7,
    categoryIcon: 'EnvironmentOutlined',
    categoryColor: '#1f6feb',
  },
];

const mapLocations = regionSnapshots.map((region) => ({
  id: region.id,
  name: region.name,
  latitude: region.latitude,
  longitude: region.longitude,
  categoryIcon: region.categoryIcon,
  categoryColor: region.categoryColor,
}));

const buildingCards = [
  { name: '中央ビル', region: '都心エリア', status: '点検 2 / 未整理 3', vendor: '東都設備', tone: 'warn' },
  { name: '南棟ビル', region: '都心エリア', status: '法定点検 1 / 進行中', vendor: '光電工業', tone: 'ok' },
  { name: '北棟ビル', region: '湾岸エリア', status: '見積依頼中', vendor: '三星サービス' },
  { name: '港タワー', region: '湾岸エリア', status: '写真整理 2件', vendor: 'アクア社', tone: 'warn' },
];

const inboxSamples = [
  { name: '写真: 受水槽_点検後', hint: '候補: 都心エリア / 中央ビル', tag: '写真' },
  { name: 'PDF: 防火設備 点検報告', hint: '候補: 都心エリア / 南棟ビル', tag: 'PDF' },
  { name: 'メモ: EV更新 見積依頼', hint: '候補: 湾岸エリア / 北棟ビル', tag: 'メモ' },
];

export function BuildingMaintenanceAreasPage() {
  return (
    <div className="bm2-grid" style={{ gap: '22px' }}>
      <section>
        <h2 className="bm2-section-title" data-testid="bm-areas-title">地域マップとビル単位ビュー</h2>
      </section>

      <section className="bm2-grid">
        <div className="bm2-card bm2-map-panel">
          <div>
            <h3>地域マップ</h3>
            <p className="bm2-highlight">地域単位でビルと点検状況を俯瞰して把握します。</p>
          </div>
          <div className="bm2-map-body">
            <div className="bm2-map-system" data-testid="bm-areas-map">
              <GeoLocationMapView
                locations={mapLocations}
                height={360}
                fallbackCenter={{ lat: 35.681236, lon: 139.767125 }}
              />
            </div>
            <div className="bm2-map-legend">
              {regionSnapshots.map((region) => (
                <div key={`${region.name}-legend`} className="bm2-map-legend-item">
                  <div>
                    <strong>{region.name}</strong>
                    <small>{region.meta}</small>
                  </div>
                  <span className={`bm2-pill${region.tone ? ` ${region.tone}` : ''}`}>{region.tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bm2-grid cols-2">
        <div className="bm2-card">
          <h3>ビル一覧</h3>
          <p className="bm2-highlight">ビル単位で未整理・点検・発注状況を確認します。</p>
          <ul className="bm2-list bm2-building-list" data-testid="bm-areas-building-list">
            {buildingCards.map((card) => (
              <li key={`${card.name}-${card.region}`}>
                <div>
                  <div>{card.name}</div>
                  <small>{card.region} / {card.vendor}</small>
                </div>
                <span className={`bm2-pill${card.tone ? ` ${card.tone}` : ''}`}>{card.status}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bm2-card">
          <h3>未整理トレイ（仮置き）</h3>
          <p className="bm2-highlight">
            写真/PDF/メモは先に保存。ビル単位に紐付けて後から整理できます。
          </p>
          <ul className="bm2-list">
            {inboxSamples.map((item) => (
              <li key={item.name}>
                <div>
                  <div>{item.name}</div>
                  <small>{item.hint}</small>
                </div>
                <span className="bm2-tag">{item.tag}</span>
              </li>
            ))}
          </ul>
          <button type="button" className="bm2-button primary" style={{ marginTop: '12px' }}>
            ビルに割り当てる
          </button>
        </div>
      </section>
    </div>
  );
}
